module.exports = __webpack_public_path__ + "img/sign_240400745_1.12228bcf.png";